import { memo } from 'react';
import { MyPageTemplate } from 'components/templates/MyPageTemplate';

type Props = {};

export const MyPage = memo((_props: Props) => {
	return <MyPageTemplate />;
});
